<form
    class="form-horizontal identity-id-proofing"
    role="form"
    novalidate
    (ngSubmit)="acceptTermsAndConditions()">
    @if (!hasBrandEula()) {
        <kno2-dialog-body>
            <div class="form-group row">
                <div class="col-sm-12">
                    <div
                        class="eula-modal"
                        [innerHTML]="eulaHtml.value()"></div>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-sm-12">
                    <label>
                        <input
                            type="checkbox"
                            name="agreeTermsAndConditions"
                            [ngModel]="acceptedTermsAndConditions()"
                            (ngModelChange)="acceptedTermsAndConditions.set($event)" />
                        I agree to terms and conditions
                    </label>
                    <button
                        type="button"
                        class="pull-right btn btn-default"
                        (click)="printTermsAndConditions()">
                        Print TOS
                    </button>
                </div>
            </div>
        </kno2-dialog-body>
    }

    @if (hasBrandEula()) {
        <kno2-dialog-body>
            <div class="form-group row">
                <div class="col-sm-12">
                    <label>
                        <input
                            type="checkbox"
                            name="agreeTermsAndConditions"
                            [ngModel]="acceptedTermsAndConditions()"
                            (ngModelChange)="acceptedTermsAndConditions.set($event)" />
                        By clicking this check box you acknowledge and accept the terms of service incorporated into your agreement with
                        {{ brandDisplayName() }}.
                    </label>
                </div>
            </div>
        </kno2-dialog-body>
    }

    <kno2-dialog-footer>
        <button
            id="OK"
            type="submit"
            class="btn btn-primary"
            [disabled]="!acceptedTermsAndConditions()">
            @if (!userProfile()?.orgIsIdProofed) {
                <span>Next</span>
            } @else {
                <span>Close</span>
            }
        </button>
    </kno2-dialog-footer>
</form>
